'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 16" {...props}><path fill="currentColor" d="M8.49.3a.584.584 0 0 1 1.02 0l8.41 14.803c.227.399-.056.897-.51.897H.59c-.454 0-.737-.498-.51-.897z" /><path fill="#fff" d="M7.902 12.362q0-.422.3-.709.298-.287.72-.287.45 0 .732.287a.95.95 0 0 1 .287.71.98.98 0 0 1-.28.72q-.282.275-.739.275-.427 0-.727-.281a.95.95 0 0 1-.293-.715m.082-4.418V4.798h1.899v3.146l-.41 2.748H8.395z" /></svg>;
const IconTriangleWarning = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconTriangleWarning;